import * as types from './actionTypes'

export function startReciveUser() {
  return { type: types.BEGIN_ADD_USER }
}
export function finishReciveUser() {
  return { type: types.FINISH_ADD_USER }
}

export function reciveUser(user) {
  return { type: types.ADD_USER, user }
}

export function addVideoViewInfo(id, folderName, videoViewInfo) {
  return { type: types.ADD_VIDEO_INFO, id, folderName, videoViewInfo }
}

export function editTrainingPlan(trainingDays, trainingReminder) {
  return { type: types.EDIT_TRAINING_PLAN, trainingDays, trainingReminder }
}

export function editTraining(trainingDays, trainingReminder) {
  return (dispatch) => {
    dispatch(editTrainingPlan(trainingDays, trainingReminder))
  }
}

export function addUser(user) {
  return (dispatch) => {
    dispatch(startReciveUser())
    dispatch(reciveUser(user))
    dispatch(finishReciveUser())
  }
}
